import React from "react";
import { MapContainer, TileLayer, Circle, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { resolveImageUrl } from "@/lib/siteContent";

// Lynchburg, TN
const CENTER = [35.282, -86.373];
const MILE_TO_METER = 1609.34;

// Inline gold pin (no external CDN, avoids broken marker icons)
const goldPin = L.divIcon({
  html:
    '<div style="width:18px;height:18px;border-radius:50%;background:#D4A25A;border:3px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,.25);"></div>',
  className: "",
  iconSize: [18, 18],
  iconAnchor: [9, 9],
});

export default function ServiceMap({ customUrl }) {
  if (customUrl && customUrl.trim()) {
    return (
      <img
        src={resolveImageUrl(customUrl)}
        alt="Service area map"
        className="w-full h-auto rounded-3xl shadow-cozy border border-cozy-gold/15"
        data-testid="service-map-custom"
      />
    );
  }

  return (
    <div
      className="relative rounded-3xl overflow-hidden shadow-cozy border border-cozy-gold/15 bg-white"
      data-testid="service-map"
      style={{ height: 420 }}
    >
      <MapContainer
        center={CENTER}
        zoom={8}
        scrollWheelZoom={false}
        className="w-full h-full"
        style={{ background: "#EFE4D6" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {/* 60-mile light red */}
        <Circle
          center={CENTER}
          radius={60 * MILE_TO_METER}
          pathOptions={{ color: "#E55A5A", fillColor: "#E55A5A", fillOpacity: 0.1, weight: 2 }}
        />
        {/* 30-mile dark grey */}
        <Circle
          center={CENTER}
          radius={30 * MILE_TO_METER}
          pathOptions={{ color: "#4A392F", fillColor: "#4A392F", fillOpacity: 0.12, weight: 2 }}
        />
        <Marker position={CENTER} icon={goldPin}>
          <Popup>Lynchburg, TN — The Cozy Cove</Popup>
        </Marker>
      </MapContainer>

      {/* Legend */}
      <div className="absolute bottom-3 left-3 bg-white/95 backdrop-blur rounded-2xl px-4 py-3 shadow-cozy text-xs space-y-1.5 border border-cozy-gold/15 z-[400]">
        <div className="flex items-center gap-2">
          <span className="inline-block w-3 h-3 rounded-full" style={{ background: "rgba(74,57,47,0.85)" }} />
          <span className="text-cozy-brown font-medium">30-mile · No travel fee</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="inline-block w-3 h-3 rounded-full" style={{ background: "rgba(229,90,90,0.85)" }} />
          <span className="text-cozy-brown font-medium">60-mile · Small travel fee</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="inline-block w-3 h-3 rounded-full" style={{ background: "#D4A25A" }} />
          <span className="text-cozy-brown font-medium">Lynchburg, TN</span>
        </div>
      </div>
    </div>
  );
}
